import { createContext, useContext } from 'react';
import { FormField, FormInfo } from 'src/components';
import { ConversationDetailsFormValues } from 'src/pages/Conversations/SidePanel/ConversationDetails/use-conversation-properties-form';

export interface ConversationPropertiesFormContextValue {
  fieldsByName: Map<string, FormField>;
  onSubmit: (
    values: ConversationDetailsFormValues,
    formInfo?: FormInfo<ConversationDetailsFormValues>,
  ) => Promise<void>;
}

export const ConversationPropertiesFormContext =
  createContext<ConversationPropertiesFormContextValue | null>(null);

export function useConversationPropertiesFormContext(): ConversationPropertiesFormContextValue {
  const value = useContext(ConversationPropertiesFormContext);

  if (!value) {
    throw new Error(
      'useConversationPropertiesFormContext must be used within ConversationSidePanelProvider',
    );
  }

  return value;
}
